// Presentation for the native profile menu; server links and lx.nav.switch own actions.
(function () {
  'use strict';
  function init() {
    var host = document.querySelector('.lxTop_P');
    if (!host || host.dataset.lpProfileObserver) { return; }
    host.dataset.lpProfileObserver = 'true';
    var hr = /^hr/i.test(document.documentElement.lang);
    var labels = hr ? {
      title:'Vaš račun', signedIn:'Trenutni račun', switchAccount:'Promijeni račun',
      search:'Pretraži račune', personal:'Osobni profili', workspaces:'Radni prostori tvrtki',
      current:'Trenutni', close:'Zatvori', empty:'Nema pronađenih računa.', signOut:'Odjavi se', preferences:'Postavke računa'
    } : {
      title:'Your account', signedIn:'Current account', switchAccount:'Switch account',
      search:'Search accounts', personal:'Personal profiles', workspaces:'Company workspaces',
      current:'Current', close:'Close', empty:'No accounts found.', signOut:'Sign out', preferences:'Account preferences'
    };
    function element(tag, className, text) {
      var node = document.createElement(tag);
      node.className = className;
      if (text) { node.textContent = text; }
      return node;
    }
    function icon(name) {
      var node = element('span', 'far fawe-' + name);
      node.setAttribute('aria-hidden', 'true');
      return node;
    }
    function decorate() {
      var menu = host.querySelector('.lxTop');
      if (!menu || menu.dataset.lpProfileReady || !window.lx || !lx.topMenu.profile) { return; }
      var body = menu.querySelector(':scope > .content');
      var oldHeader = menu.querySelector(':scope > .hdr');
      if (!body || !oldHeader) { return; }
      menu.dataset.lpProfileReady = 'true';
      menu.classList.add('lp-profile-menu');
      menu.setAttribute('role', 'region');
      menu.setAttribute('aria-label', labels.title);
      var header = element('header', 'lp-profile-header');
      var titleRow = element('div', 'lp-profile-title-row');
      titleRow.appendChild(element('h2', 'lp-profile-title', labels.title));
      var close = element('button', 't-Button t-Button--noLabel lp-profile-close');
      close.type = 'button';
      close.setAttribute('aria-label', labels.close);
      close.appendChild(icon('times'));
      var trigger = host.querySelector('.t-Button--navBar');
      function dismiss() {
        lx.topMenu.removeClickListener();
        if (trigger) { trigger.focus(); }
      }
      close.addEventListener('click', dismiss);
      menu.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); dismiss(); }
      });
      titleRow.appendChild(close);
      header.appendChild(titleRow);
      var identity = element('div', 'lp-profile-identity');
      var rows = Array.prototype.slice.call(body.querySelectorAll('.box'));
      var currentRow = rows.find(function (row) { return row.classList.contains('current'); });
      var currentPicture = currentRow && currentRow.querySelector('.profilePic');
      if (currentPicture) { identity.appendChild(currentPicture.cloneNode(true)); }
      else { identity.appendChild(icon('user-alt')); }
      var identityText = element('div', 'lp-profile-identity-text');
      var currentName = currentRow && currentRow.querySelector('.name');
      identityText.appendChild(element('div', 'lp-profile-name', currentName ? currentName.textContent : lx.topMenu.profile.currentName || ''));
      identityText.appendChild(element('div', 'lp-profile-muted', labels.signedIn));
      identity.appendChild(identityText);
      header.appendChild(identity);
      menu.insertBefore(header, oldHeader);
      var actions = element('nav', 'lp-profile-actions');
      actions.setAttribute('aria-label', labels.preferences);
      var preferences = element('details', 'lp-profile-preferences');
      var summary = element('summary', 'lp-profile-preferences-toggle');
      summary.appendChild(element('span', 'lp-profile-preferences-label', labels.preferences));
      var disclosureArrow = icon('chevron-right');
      disclosureArrow.classList.add('lp-profile-disclosure-arrow');
      summary.appendChild(disclosureArrow);
      preferences.appendChild(summary);
      preferences.appendChild(actions);
      var footer = element('footer', 'lp-profile-footer');
      var buttons = Array.prototype.slice.call(oldHeader.querySelectorAll('.btnContainer > .t-Button'));
      buttons.forEach(function (button) {
        var href = button.getAttribute('href') || '';
        var signOut = /apex_authentication\.logout/i.test(href);
        // Routes come from the server; inspect them only to select a presentation icon.
        var decoded = href;
        try { decoded = decodeURIComponent(href); } catch (ignore) { /* Keep original route. */ }
        var name = signOut ? 'sign-out' : (/pageId=202(?:&|$)|\/password(?:\?|$)/i.test(decoded) ? 'key' :
          (/pageId=435(?:&|$)|\/push-notifications(?:\?|$)/i.test(decoded) ? 'bell' : 'cog'));
        button.className = 't-Button lp-profile-action';
        button.prepend(icon(name));
        if (signOut) {
          var label = button.querySelector('.t-Button-label');
          if (label) { label.textContent = labels.signOut; }
          footer.appendChild(button);
        } else {
          actions.appendChild(button);
        }
      });
      oldHeader.remove();
      var search = body.querySelector('.topMenuSearch');
      var input = search && search.querySelector('input');
      var heading = body.querySelector('.hdrTitle');
      var searchArea = element('div', 'lp-profile-search');
      var label = element('label', 'lp-profile-search-label', labels.switchAccount);
      if (input) { label.htmlFor = input.id; }
      searchArea.appendChild(label);
      if (heading) { heading.remove(); }
      if (input) {
        input.placeholder = labels.search;
        search.prepend(icon('search'));
        searchArea.appendChild(search);
      }
      menu.insertBefore(searchArea, body);
      var results = body.querySelector('#topMenuProfileResults');
      if (!results) {
        results = element('div', 'topMenuResults');
        results.id = 'topMenuProfileResults';
        rows.forEach(function (row) { results.appendChild(row); });
        body.appendChild(results);
      }
      var sourceRows = lx.topMenu.profile.rows.slice();
      if (lx.topMenu.pubProfile && sourceRows.length) { sourceRows.splice(1, 0, lx.topMenu.pubProfile); }
      var personalGroup = element('section', 'lp-profile-group');
      personalGroup.setAttribute('aria-label', labels.personal);
      personalGroup.appendChild(element('h3', 'lp-profile-group-title', labels.personal));
      var workspaceGroup = element('section', 'lp-profile-group');
      workspaceGroup.setAttribute('aria-label', labels.workspaces);
      workspaceGroup.appendChild(element('h3', 'lp-profile-group-title', labels.workspaces));
      rows.forEach(function (row, index) {
        var profile = sourceRows[index] || {};
        // The native team account (id 0) belongs with personal profiles, as requested.
        var personal = profile.type === 'FOL' || Number(profile.id) === 0;
        (personal ? personalGroup : workspaceGroup).appendChild(row);
      });
      var groups = [personalGroup, workspaceGroup];
      groups.forEach(function (group) {
        group.hidden = !group.querySelector('.box');
        results.appendChild(group);
      });
      var empty = element('p', 'lp-profile-empty', labels.empty);
      empty.setAttribute('role', 'status');
      empty.hidden = true;
      body.appendChild(empty);
      rows.forEach(function (row) {
        var name = row.querySelector('.name');
        if (name) { name.title = name.textContent; }
        var subBox = row.querySelector('.subBox');
        if (row.classList.contains('current')) {
          row.setAttribute('aria-current', 'true');
          var current = element('span', 'lp-profile-current', labels.current);
          current.prepend(icon('check'));
          var text = row.querySelector('.txt');
          if (text) { text.appendChild(current); }
        } else if (row.onclick && subBox) {
          var nativeSwitch = row.onclick;
          row.removeAttribute('onclick');
          row.style.removeProperty('cursor');
          var select = element('button', 'lp-profile-select');
          select.type = 'button';
          select.setAttribute('aria-label', labels.switchAccount + ': ' + (name ? name.textContent : ''));
          select.addEventListener('click', function (event) { nativeSwitch.call(row, event); });
          subBox.appendChild(select);
        }
      });
      if (input) {
        // This drawer owns filtering once decorated; retain the original row action handlers.
        input.removeAttribute('onkeyup');
        input.removeAttribute('onkeydown');
        input.addEventListener('input', function () {
          var term = input.value.trim().toLocaleLowerCase();
          var count = 0;
          rows.forEach(function (row) {
            var name = row.querySelector('.name');
            var matches = !term || (name && name.textContent.toLocaleLowerCase().includes(term));
            row.style.display = matches ? '' : 'none';
            if (matches) { count++; }
          });
          groups.forEach(function (group) {
            group.hidden = !Array.prototype.some.call(group.querySelectorAll('.box'), function (row) { return row.style.display !== 'none'; });
          });
          empty.hidden = count > 0;
        });
        input.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter') { return; }
          event.preventDefault();
          if (event.ctrlKey) {
            var first = rows.find(function (row) { return row.style.display !== 'none' && row.querySelector('.lp-profile-select'); });
            if (first) { first.querySelector('.lp-profile-select').click(); }
          }
        });
      }
      if (actions.children.length) { menu.appendChild(preferences); }
      if (footer.children.length) { menu.appendChild(footer); }
      var appHeader = document.getElementById('t_Header');
      if (appHeader) {
        function geometry() { menu.style.setProperty('--lp-profile-top', Math.max(0, appHeader.getBoundingClientRect().bottom) + 'px'); }
        geometry();
        var sizeObserver = new ResizeObserver(geometry);
        sizeObserver.observe(appHeader);
        // Native refresh removes the drawer; release its geometry observer.
        var removalObserver = new MutationObserver(function () {
          if (!menu.isConnected) { sizeObserver.disconnect(); removalObserver.disconnect(); }
        });
        removalObserver.observe(host, {childList:true});
      }
    }
    new MutationObserver(decorate).observe(host, {childList:true, subtree:true});
    decorate();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
